/* eslint-disable max-len */
/* eslint-disable no-console */
import {Button} from 'antd';
import React from 'react';

interface FinalDetailProps {
  finalPage: () => void;
}

const FinalDetail: React.FC<FinalDetailProps> = ({finalPage}) => {
  return (
    <>
      <h2 style={{fontSize: 45, textAlign: 'center'}}>Awesome</h2>
      <p
        style={{
          fontSize: 18,
          fontWeight: 500,
          textAlign: 'center',
          padding: '0px 90px 0px 90px'
        }}
      >
        You have completed filling your details. Now step into a cleaner and
        greener world with us!
      </p>
      <div style={{padding: '12px 0px'}}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Button
            type="primary"
            style={{
              borderRadius: '6px',
              padding: '6px 24px',
              height: '40px'
            }}
            onClick={() => {
              finalPage();
            }}
          >
            Lets get started
          </Button>
        </div>
      </div>
    </>
  );
};

export default FinalDetail;
